// Spanish
export default {
  newVersionAvailable: 'Nueva versión disponible',
  versionInfo: 'Una nueva versión de {appName} está disponible. Por favor, recargue la página para actualizar a la versión {version}.',
  reload: 'Recargar',
  later: 'Más tarde',
};
